import * as brandColors from '../../utils/brandColors';

export default () => ({
  body: {
    wordBreak: 'break-word',
    color: brandColors.grey[800],
    backgroundColor: brandColors.grey[200],
    marginTop: '4px',
    marginRight: '1rem',
    padding: '8px',
    borderRadius: '0px 6px 6px 6px',
    fontSize: '14px',
    display: 'inline-block',
    whiteSpace: 'pre-wrap',
  },
});
